<template>
  <div class="clearfix screen">
    <Class class="pull-left class" />
    <Banner class="pull-left banner" />
    <User class="pull-right user" />
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import Class from '@/components/Class';
import User from './components/User';
import Banner from './components/Banner';

export default {
  components: {
    User,
    Class,
    Banner,
  },
};
</script>
